module.exports = __webpack_public_path__ + "bin/342732c568a8739ef3355607b3207322.jpg";